import { render, staticRenderFns } from "./Bitrix.vue?vue&type=template&id=22dae72d&scoped=true&"
import script from "./Bitrix.vue?vue&type=script&lang=js&"
export * from "./Bitrix.vue?vue&type=script&lang=js&"
import style0 from "./Bitrix.vue?vue&type=style&index=0&id=22dae72d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dae72d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCol,VList,VListItem,VListItemContent,VListItemGroup,VRow,VSubheader})
